import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from '@/contexts/LitSessionProvider';
import UserWallets from '@/components/userSettings/UserWallets';
export default function WalletsDesktop() {
  const router = useRouter();
  const {
    PKP,
    litSession
  } = useSession();
  useEffect(() => {
    if (!litSession || !PKP) {
      router.push('/home');
    }
  }, [litSession, PKP]);
  return <div className='flex flex-col' data-sentry-component="WalletsDesktop" data-sentry-source-file="WalletsDesktop.tsx">
      <div className='grow'>
        <div className='wallets-wrapper'>
          <div className='flex  items-center pb-4'>
            <div className='flex flex-col w-2/3 title text-genius-cream text-[20px] font-light'>
              Genius Cloud Wallets
            </div>
          </div>
        </div>
        <UserWallets data-sentry-element="UserWallets" data-sentry-source-file="WalletsDesktop.tsx" />
      </div>
    </div>;
}